import { DateTime } from "luxon"
import EUsersTypes from "../../../enums/EUsersTypes"
import { displayMessage } from "../../../services/helper"

export default (mobile_mode) => {

    return (
        [
            {
                field: 'creator',
                headerName: displayMessage('CREATOR'),
                width: 150,
                headerAlign: "center",
                sortable: false,
                align: 'center',
                valueGetter: function (params) {
                    return `${params?.value || ''}`
                }
            },
            {
                field: 'type',
                headerName: displayMessage('USER_TYPE'),
                width: 120,
                headerAlign: "center",
                sortable: false,
                align: 'center',
                valueGetter: function (params) {
                    //UserTypes go from 1 to 3, arrey starts at 0
                    return `${params?.value - 1 >= 0 ? Object.values(EUsersTypes)[params?.value - 1].description : ''}`
                }
            },
            {
                field: 'created_at',
                headerName: displayMessage('DATE'),
                width: 100,
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                valueFormatter: (params) => {
                    if (!params?.value) {
                        return params?.value
                    }
                    const data = DateTime.fromISO(params.value).toUTC();
                    return data.toFormat('dd/MM/yyyy')
                }
            },
            {
                field: 'text',
                headerName: displayMessage('COMMENT'),
                flex: 1,
                minWidth: mobile_mode ? 300 : 120,
                type: 'string',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
            }
        ]
    )
}